import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'

export function ActivitySkeleton() {
  return (
    <div className="flex max-w-6xl flex-col gap-8">
      <div className="flex flex-row gap-12 lg:gap-24">
        {Array.from({ length: 2 }).map((_, index) => (
          <Skeleton className="h-12 w-[144px]" key={index} />
        ))}
      </div>
      <div className="flex flex-col gap-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton className="h-12 w-full" key={index} />
        ))}
      </div>
    </div>
  )
}
